import React from 'react'
import Workbanner from '../components/work/Workbanner.jsx'
import Connect from '../components/Connect.jsx'
import Worktoggle from '../components/work/Worktoggle.jsx'

const Work = () => {
  return (
    <>
      <div className="">
      <Workbanner />
      <div className="overflow-x-hidden">
          <Worktoggle />
      </div>
      <Connect />
      </div>
    </>
  )
}

export default Work
